export default {
  state: {
    marketList: [
      { id: 'at', name: 'Austria' },
      { id: 'au', name: 'Australia' },
      { id: 'br', name: 'Brazil' },
      { id: 'ca', name: 'Canada' },
      { id: 'ch', name: 'Switzerland' },
      { id: 'de', name: 'Germany' },
      { id: 'dk', name: 'Denmark' },
      { id: 'ee', name: 'Estonia' },
      { id: 'es', name: 'Spain' },
      { id: 'fi', name: 'Finland' },
      { id: 'fr', name: 'France' },
      { id: 'gb', name: 'United Kingdom' },
      { id: 'it', name: 'Italy' },
      { id: 'lt', name: 'Lithuania' },
      { id: 'lv', name: 'Latvia' },
      { id: 'mx', name: 'Mexico' },
      { id: 'play', name: 'Netherlands-EN' },
      { id: 'nl', name: 'Netherlands-NL' },
      { id: 'no', name: 'Norway' },
      { id: 'nz', name: 'New Zealand' },
      { id: 'ro', name: 'Romania' },
      { id: 'se', name: 'Sweden' },
      { id: 'us', name: 'United States' },
    ],
  },
  getters: {
    marketList(state) {
      return state.marketList
    },
    marketName: state => id => {
      return state.marketList.find(market => market.id === id).name
    },
  },
}
